import { GameConfigs } from '../../lib/globals/GameConfigs';

const currencies = {
	DMO: { symbol: 'DMO', code: 'DMO' },
	USD: { symbol: '$', code: 'USD' },
	EUR: { symbol: '€', code: 'EUR' },
	AED: { symbol: 'د.إ', code: 'AED' },
	ALL: { symbol: 'L', code: 'ALL' },
	AMD: { symbol: 'Դ', code: 'AMD' },
	ARS: { symbol: '$', code: 'ARS' },
	AUD: { symbol: 'A$', code: 'AUD' },
	AZN: { symbol: '₼', code: 'AZN' },
	BDT: { symbol: '৳', code: 'BDT' },
	BGN: { symbol: 'Лв', code: 'BGN' },
	BMD: { symbol: '$', code: 'BMD' },
	BRL: { symbol: 'R$', code: 'BRL' },
	CAD: { symbol: 'C$', code: 'CAD' },
	CDF: { symbol: 'FC', code: 'CDF' },
	CHF: { symbol: '₣', code: 'CHF' },
	CLP: { symbol: '$', code: 'CLP' },
	CNY: { symbol: '¥', code: 'CNY' },
	COP: { symbol: '$', code: 'COP' },
	CRC: { symbol: '₡', code: 'CRC' },
	CZK: { symbol: 'Kč', code: 'CZK' },
	DKK: { symbol: 'Kr.', code: 'DKK' },
	GBP: { symbol: '£', code: 'GBP' },
	GEL: { symbol: '₾', code: 'GEL' },
	GHS: { symbol: 'GH¢', code: 'GHS' },
	GTQ: { symbol: 'Q', code: 'GTQ' },
	HKD: { symbol: 'HK$', code: 'HKD' },
	HRK: { symbol: 'kn', code: 'HRK' },
	HTG: { symbol: 'G', code: 'HTG' },
	HUF: { symbol: 'Ft', code: 'HUF' },
	IDR: { symbol: 'Rp', code: 'IDR' },
	ILS: { symbol: '₪', code: 'ILS' },
	INR: { symbol: '₹', code: 'INR' },
	IQD: { symbol: 'ع.د', code: 'IQD' },
	IRR: { symbol: '﷼', code: 'IRR' },
	ISK: { symbol: 'Íkr', code: 'ISK' },
	JPY: { symbol: '¥', code: 'JPY' },
	KES: { symbol: '/=', code: 'KES' },
	KGS: { symbol: 'Лв', code: 'KGS' },
	KRW: { symbol: '₩', code: 'KRW' },
	KWD: { symbol: 'د.ك', code: 'KWD' },
	KYD: { symbol: '$', code: 'KYD' },
	KZT: { symbol: '₸', code: 'KZT' },
	MAD: { symbol: 'MAD', code: 'MAD' },
	MDL: { symbol: 'L', code: 'MDL' },
	MKD: { symbol: 'Ден', code: 'MKD' },
	MMK: { symbol: 'K', code: 'MMK' },
	MNT: { symbol: '₮', code: 'MNT' },
	MXN: { symbol: 'Mex$', code: 'MXN' },
	MYR: { symbol: 'RM', code: 'MYR' },
	NAD: { symbol: 'N$', code: 'NAD' },
	NGN: { symbol: '₦', code: 'NGN' },
	NOK: { symbol: 'kr', code: 'NOK' },
	NZD: { symbol: '$', code: 'NZD' },
	PEN: { symbol: 'S/', code: 'PEN' },
	PLN: { symbol: 'zł', code: 'PLN' },
	PYG: { symbol: '₲', code: 'PYG' },
	RON: { symbol: 'lei', code: 'RON' },
	RUB: { symbol: '₽', code: 'RUB' },
	SAR: { symbol: '﷼', code: 'SAR' },
	SEK: { symbol: 'kr', code: 'SEK' },
	SGD: { symbol: 'S$', code: 'SGD' },
	SLL: { symbol: 'Le', code: 'SLL' },
	THB: { symbol: '฿', code: 'THB' },
	TMT: { symbol: 'T', code: 'TMT' },
	TND: { symbol: 'د.ت', code: 'TND' },
	TRY: { symbol: '₺', code: 'TRY' },
	TWD: { symbol: 'NT$', code: 'TWD' },
	TZS: { symbol: 'TSh', code: 'TZS' },
	UAH: { symbol: '₴', code: 'UAH' },
	UGX: { symbol: 'USh', code: 'UGX' },
	UYU: { symbol: '$U', code: 'UYU' },
	UZS: { symbol: "so'm", code: 'UZS' },
	VND: { symbol: '₫', code: 'VND' },
	XAF: { symbol: 'FCFA', code: 'XAF' },
	XOF: { symbol: 'CFA', code: 'XOF' },
	ZAR: { symbol: 'R', code: 'ZAR' },
	ZMW: { symbol: 'ZK', code: 'ZMW' },
	BAM: { symbol: 'KM', code: 'BAM' },
	PHP: { symbol: '₱', code: 'PHP' },
	BYN: { symbol: 'Rbl', code: 'BYN' },
	ETB: { symbol: 'ብር', code: 'ETB' },
	PKR: { symbol: 'Rs', code: 'PKR' },
	BTC: { symbol: 'BTC', code: 'BTC' },
	ETH: { symbol: 'ETH', code: 'ETH' },
	DOG: { symbol: 'DOG', code: 'DOG' },
	DOGE: { symbol: 'DOGE', code: 'DOGE' },
	XDG: { symbol: 'XDG', code: 'XDG' },
	USDT: { symbol: 'USDT', code: 'USDT' },
	LTC: { symbol: 'LTC', code: 'LTC' },
	BNB: { symbol: 'BNB', code: 'BNB' },
	USDC: { symbol: 'USDC', code: 'USDC' },
	mBTC: { symbol: 'mBTC', code: 'mBTC' },
	mETH: { symbol: 'mETH', code: 'mETH' },
	EGP: { symbol: '£', code: 'EGP' },
	KHR: { symbol: '₭', code: 'KHR' },
	LAK: { symbol: '₭', code: 'LAK' },
	MVR: { symbol: 'Rf', code: 'MVR' },
	MBC: { symbol: 'mBTC', code: 'MBC' },
	FTN: { symbol: 'FTN', code: 'FTN' },
	IRT: { symbol: 'IRT', code: 'IRT' },
	SOS: { symbol: 'SOS', code: 'SOS' },
	MBT: { symbol: 'mBT', code: 'MBT' },
	VES: { symbol: 'Bs.S', code: 'VES' },
	TJS: { symbol: 'TJS', code: 'TJS' },
	AOA: { symbol: 'AOA', code: 'AOA' },
	BHD: { symbol: 'BHD', code: 'BHD' },
	BOB: { symbol: 'BOB', code: 'BOB' },
	BZD: { symbol: 'BZD', code: 'BZD' },
	SKK: { symbol: 'SKK', code: 'SKK' },
	DZD: { symbol: 'DZD', code: 'DZD' },
	JOD: { symbol: 'JOD', code: 'JOD' },
	MZN: { symbol: 'MZN', code: 'MZN' },
	OMR: { symbol: 'OMR', code: 'OMR' },
	QAR: { symbol: 'QAR', code: 'QAR' },
	RSD: { symbol: 'RSD', code: 'RSD' },
	SDG: { symbol: 'SDG', code: 'SDG' },
	uBTC: { symbol: 'uBTC', code: 'uBTC' },
	mLTC: { symbol: 'mLTC', code: 'mLTC' },
	MBCH: { symbol: 'MBCH', code: 'MBCH' },
	TRX: { symbol: 'TRX', code: 'TRX' },
	SHIB: { symbol: 'SHIB', code: 'SHIB' },
	XRP: { symbol: 'XRP', code: 'XRP' },
	XLM: { symbol: 'XLM', code: 'XLM' },
	DASH: { symbol: 'DASH', code: 'DASH' },
	ADA: { symbol: 'ADA', code: 'ADA' },
	CFA: { symbol: 'CFA', code: 'CFA' }
};

export function getCurrencySymbol(currency, custom) {
	if (!currencies[currency]) {
		return [];
	}

	let result = [currencies[currency].symbol, 'left'];

	if (currency === 'GEL') {
		result = [currencies[currency].symbol, 'right'];
	}
	if (custom) {
		if (currency === 'USD' || currency === 'EUR') {
			result = [currencies[currency].symbol, 'left'];
		} else {
			result = [currencies[currency].symbol, 'right'];
		}
	}

	return result;
}

export function formatValue(value) {
	return parseFloat(value).toLocaleString(undefined, {
		minimumFractionDigits: GameConfigs.config.currency_prec,
		maximumFractionDigits: GameConfigs.config.currency_prec
	});
}

export function formatCurrencyValue(
	value,
	currency,
	prec,
	bonus,
	haveCurrency
) {
	const precision =
		prec !== undefined ? prec : GameConfigs.config.currency_prec;
	let res = parseFloat(value).toLocaleString(undefined, {
		minimumFractionDigits: precision,
		maximumFractionDigits: precision
	});

	if (currency[1] === 'left') {
		res = currency[0] + res;
	} else {
		if (haveCurrency !== undefined) {
			return res;
		} else {
			res = res + ' ' + currency[0];
		}
	}

	if (bonus !== undefined && bonus) {
		res = parseFloat(value).toLocaleString();
	}

	return res;
}
